import React from "react";
import appLogo from "../assets/img/app_logo.png";
// import Spinner from "./Spinner";

export default function Form({ faire, children, colClasses, hideLogo }) {
  return (
    <>
      <div className="row justify-content-center">
        <div className={colClasses}>
          {!hideLogo && (
            <div className="text-center animate__animated animate__infinite animate__pulse">
              <img
                className="tyn-logo taille-du-logo-form my-tyn-logo"
                src={appLogo}
                alt="Logo_app"
              />
            </div>
          )}
          <div className="card border-0">
            <div className="p-4">
              <h3>{faire}</h3>
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
